import axios from 'axios';
import config from '../../../config';
import { bus } from '@/main';
import { mapGetters } from 'vuex';

const state = {
  image: [],
  evento: [],
  eventoAsync: [],
  invito: [],
  eventoView: [],
  eventi: [],
  eventiFiltrati: [],
  partecipazione: [],
  partecipazioneAsync: [],
  iscrizione: [],
  partecipazioni: [],
  classifica: [],
  classificaGenerale: [],
  ranking: [],
  partecipazioniFiltrati: [],
  categorieEvento: [],
  rankingPersonale: [],
  rankingGenerale: [],
  filtroEventi: null,
  filtroEventiHome: null,
  eventoSpeciale:false
};

const getters = {
  getImage: () => state.image,
  getEvento: () => state.evento,
  getEeventoAsync: () => state.eventoAsync,
  getInvito: () => state.invito,
  getEventoView: () => state.eventoView,
  getPartecipazione: () => state.partecipazione,
  getPartecipazioneAsync: () => state.partecipazioneAsync,
  getPartecipazioniView: () => state.partecipazioni,
  getClassificaGeneraleView: () => state.classificaGenerale,
  getEventiView: () => state.eventi,
  getClassificaEventoView: () => state.classifica,
  getRankingView: () => state.ranking,
  getCategorieEvento: () => state.categorieEvento,
  getIscrizione: () => state.iscrizione,
  getRankingGeneraleView: () => state.rankingGenerale,
  getFiltroEventi: () => state.filtroEventi,
  getFiltroEventiHome: () => state.filtroEventiHome,
  getRankingPersonaleView: () => state.rankingPersonale,
  getEventoSpeciale: () => state.eventoSpeciale,
};

const actions = {
  loadEvento({ commit }, idItem) {
    axios
      .get(config.ROOT_API + '/api/eventi/' + idItem)
      .then(function (response) {
        commit('setEvento', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setEvento', null);
      });
  },

  loadEventoAsync({ commit }, idItem) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/eventi/' + idItem)
        .then(function (response) {
          commit('setEvento', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          reject(err);
          commit('setEvento', null);
        });
    });
  },
  loadInvito({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/eventi/' + itemId + '/invito')
      .then(function (response) {
        commit('loadInvito', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        // eslint-disable-next-line no-console
        console.log(err);
      });
  },

  loadPiazzola({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/eventi/' + itemId + '/piazzola')
      .then(function (response) {
        commit('loadPiazzolaAction', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        // eslint-disable-next-line no-console
        console.log(err);
      });
  },

  loadEventoView({ commit }, idItem) {
    axios
      .get(config.ROOT_API + '/api/eventiview/' + idItem.idEvento)
      .then(function (response) {
        commit('setEventoView', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setEventoView', null);
      });
  },
  createEvento({ dispatch, commit }, newItem) {
    axios
      .post(config.ROOT_API + '/api/eventi', newItem.item)
      .then(function (response) {
        commit('addEvento');
        dispatch('loadEventiView(newItem.maxAnnoSportivo)');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  updateEvento({ dispatch, commit }, editItem) {
    // rimuovo l'immagine dall'oggetto associazione perchè è gestita con un servizio apposito
    delete editItem.image;
    axios
      .patch(config.ROOT_API + '/api/eventi', editItem.editItem)
      .then(function (response) {
        commit('editEvento');
        dispatch('loadEventiView(editItem.annoSportivo)');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  deleteEvento({ dispatch, commit }, item) {
    axios
      .delete(config.ROOT_API + '/api/eventi/' + item.id)
      .then(function (response) {
        commit('removeEvento', response.data);
        dispatch('loadEventiView(editItem.annoSportivo)');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },

  deleteEventi({ dispatch, commit }, items) {
    items.forEach((item) => {
      // se l'evento è attiva, la disabilito
      if (item.isAttivo) {
        dispatch('deleteEvento', item);
      }
    });
  },
  loadEventiView({ commit },annosportivoId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/eventiview/associato/anno/' + annosportivoId + '/' + this.getters.userData.id )
        .then(function (response) {
          commit('setEventi', response.data);
          resolve(response);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          commit('setEventi', null);
          reject(err);
        });
    });
  },
  loadEventiViewAdmin({ commit },annosportivoId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/eventiview/anno/'+annosportivoId)
        .then(function (response) {
          commit('setEventi', response.data);
          resolve(response);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          commit('setEventi', null);
          reject(err);
        });
    });
  },
  loadEventiViewAnnoSportivo({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/eventiview/')
        .then(function (response) {
          commit('setEventi', response.data);
          resolve(response);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          commit('setEventi', null);
          reject(err);
        });
    });
  },
  loadEventiViewPublic({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/eventiview/public')
        .then(function (response) {
          commit('setEventi', response.data);
          resolve(response);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          commit('setEventi', null);
          reject(err);
        });
    });
  },

  loadPartecipazioniByIscritto({ commit }, idItem) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/partecipazioniview/evento/' + idItem)
        .then(function (response) {
          commit('setPartecipazioni', response.data);
          resolve(response);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          commit('setPartecipazioni', null);
          reject(err);
        });
    });
  },

  existIscrizione({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/partecipazioniview/partecipazione/' + item.idEvento+ "/"+item.idAssociato)
        .then(function (response) {
          commit('setIscrittoEventoSpeciale', response.data);
          resolve(response);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          commit('setIscrittoEventoSpeciale', null);
          reject(err);
        });
    });
  },

  getPartecipazione({ commit }, idItem) {
    axios
      .get(config.ROOT_API + '/api/partecipazioni/' + idItem)
      .then(function (response) {
        commit('setPartecipazione', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setPartecipazione', null);
      });
  },

  getPartecipazioneAsync({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/partecipazioni/' + id)
        .then(function (response) {
          commit('setPartecipazione', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          reject(err);
        });
    });
  },

  inviaNotificaPubblicazioneEvento({ dispatch }, item) {
    axios
      .post(config.ROOT_API + '/api/eventi/' + item.IdEvento + '/inviaavviso/', item.IdEvento)
      .then(function (response) {
        dispatch('loadEventiView(item.AnnoSportivoId)');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  createPartecipazione({ dispatch, commit }, newItem) {
    axios
      .post(config.ROOT_API + '/api/eventi/' + newItem.IdEvento + '/partecipazioni/', newItem)
      .then(function (response) {
        commit('addPrenotazione');
        dispatch('loadEventiView(newItem.annoSportivoId)');
        bus.$emit('close-prenotazioneDialog', {
          status: false,
          update: true,
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  updatePartecipazione({ dispatch, commit }, newItem) {
    axios
      .patch(config.ROOT_API + '/api/eventi/' + newItem.IdEvento + '/partecipazioni/' + newItem.Id, newItem)
      .then(function (response) {
        commit('editPartecipazione');
        dispatch('loadEventiView(newItem.annoSportivoId)');
        bus.$emit('close-prenotazioneDialog', {
          status: false,
          update: true,
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },

  deletePartecipazione({ dispatch, commit }, item) {
    axios
      .delete(config.ROOT_API + '/api/eventi/' + item.eventoId + '/partecipazioni/' + item.id, item)
      .then(function (response) {
        commit('removePartecipazione', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  deletePartecipazioni({ dispatch, commit }, item) {
    axios
      .post(config.ROOT_API + '/api/eventi/' + item.eventoId + '/removepartecipazioni', item.partecipazioniId)
      .then(function (response) {
        commit('removePartecipazioni', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },

  updatePartecipazioneIscrizioni({ dispatch, commit }, newItem) {
    axios
      .patch(config.ROOT_API + '/api/eventi/' + newItem.IdEvento + '/partecipazioni/' + newItem.Id, newItem)
      .then(function (response) {
        commit('editPartecipazione');
        dispatch('loadPartecipazioni', newItem.IdEvento);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },

  filterCol({ dispatch, commit }, obj) {
    // filtra i risultati su una specifica colonna
    state.eventiFiltrati = state.eventi.filter((a) => {
      if (typeof a[obj.col] !== 'string') {
        // filtro per stato (attivo / non attivo / tutti)
        if (obj.val == 'all') {
          return true;
        } else {
          // eslint-disable-next-line
          return a[obj.col] == obj.val;
        }
      } else {
        return a[obj.col].toLowerCase().indexOf(obj.val.toLowerCase()) > -1;
      }
    });
  },
  search({ commit }, val) {
    // filtra i risultati su tutte le colonne
    if (val) {
      state.eventiFiltrati = state.eventi.filter((a) => {
        return JSON.stringify(a).toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }
  },
  loadImage({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/eventi/' + itemId + '/image')
      .then(function (response) {
        commit('setImage', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setImage', null);
      });
  },
  updateLogo({ commit }, data) {
    axios
      .post(config.ROOT_API + '/api/eventi/' + data.id + '/image', data.uploadData)
      .then(function (response) {
        commit('editImage', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('editImage', null);
      });
  },
  updateLocandina({ commit }, data) {
    axios
      .post(config.ROOT_API + '/api/eventi/' + data.id + '/invito', data.uploadData)
      .then(function (response) {
        commit('editLocandina', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('editLocandina', null);
      });
  },
  updatePiazzola({ commit, dispatch }, data) {
    axios
      .post(config.ROOT_API + '/api/eventi/' + data.id + '/piazzola', data.uploadData)
      .then(function (response) {
        commit('editPiazzola', response.data);
        dispatch('loadEventiView');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('editPiazzola', null);
      });
  },

  updatePiazzolaAsync({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.ROOT_API + '/api/eventi/' + data.id + '/piazzola', data.uploadData)
        .then(function (response) {
          commit('editPiazzola', response.data);
          dispatch('loadEventiView(data.idAnnoSportivo)');
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          commit('editPiazzola', null);
        });
    });
  },

  async updateClassifica({ commit }, data) {
    axios
      .post(config.ROOT_API + '/api/classificaview/' + data.id + '/classifica', data.uploadData)
      .then(function (response) {
        commit('editClassifica', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('editClassifica', null);
      });
  },

  async removeClassifica({ commit }, itemId) {
    axios
      .delete(config.ROOT_API + '/api/classificaview/' + itemId + '/classifica')
      .then(function (response) {
        commit('removeClassifica', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('removeClassifica', null);
      });
  },

  loadPartecipazioni({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/eventiview/' + itemId.idEvento + '/'+ itemId.idAnnoSportivo + '/partecipazioniview')
      .then(function (response) {
        commit('setPartecipazioni', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setPartecipazioni', null);
      });
  },
  exportIscrizioniXLS({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/eventiview/' + itemId + '/exportCsain')
      .then(function (response) {
        commit('exportIscrizioniXLS', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  exportIscrizioniXLSPunteggio({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/eventiview/' + itemId + '/exportCsainPunteggio')
      .then(function (response) {
        commit('exportIscrizioniXLS', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },

  exportClassificaXLS({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/classificaview/' + itemId + '/classificaXLS', { timeout: 180000 })
      //.get(config.ROOT_API + '/api/eventiview/' + itemId + '/exportCsain')
      .then(function (response) {
        commit('exportIscrizioniXLS', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },

  loadClassificaEvento({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/classificaview/evento/' + itemId)
      .then(function (response) {
        commit('setClassificaEvento', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setClassificaEvento', null);
      });
  },

  loadClassificaRankingView({ commit }, filter) {
    axios
      .get(config.ROOT_API + '/api/classificaview/ranking?filter=' + filter)
      .then(function (response) {
        commit('setRanking', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setRanking', null);
      });
  },

  loadRankingGeneraleView({ commit }, filter) {
    axios
      .post(config.ROOT_API + '/api/classificaview/filterRanking', filter)
      .then(function (response) {
        commit('setRankingGenerale', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setRankingGenerale', null);
      });
  },

  calcolaRanking({ commit }, annoSportivo) {
    axios
      .post(config.ROOT_API + '/api/classificaview/calcolaRanking', annoSportivo)
      .then(function (response) {
        commit('setCalcolaRanking', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setCalcolaRanking', null);
      });
  },

  exportRankingGeneraleXLS({ commit }, filter) {
    axios
      .post(config.ROOT_API + '/api/classificaview/exportRanking', filter)
      .then(function (response) {
        commit('exportRankingGeneraleXLS', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },

  loadClassificaGeneraleView({ dispatch, commit }, filter) {
    axios
      .post(config.ROOT_API + '/api/classificaview/filterGenerale', filter)
      .then(function (response) {
        commit('setClassificaGenerale', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setClassificaGenerale', null);
      });
  },

  loadRankingPersonaleView({ dispatch, commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/classificaview/ranking/' + itemId)
      .then(function (response) {
        commit('setRankingPersonale', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        commit('setRankingPersonale', null);
      });
  },

  exportClassificaGeneraleXLS({ commit }, filter) {
    axios
      .post(config.ROOT_API + '/api/classificaview/exportGenerale', filter)
      .then(function (response) {
        commit('exportClassificaGeneraleXLS', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },

  exportCalendarioXLS({ commit }, annosportivoId) {
    axios
      .get(config.ROOT_API + '/api/eventiview/' + annosportivoId + '/exportCalendario')
      .then(function (response) {
        commit('exportCalendarioXLS', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },

  exportClassificaPDF({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/classificaview/' + itemId + '/classifica', { timeout: 180000 })
      .then(function (response) {
        commit('exportClassificaPDF', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  saveFiltroEventi({ commit }, filtro) {
    commit('setFiltroEventi', filtro);
  },
  saveFiltroEventiHome({ commit }, filtro) {
    commit('setFiltroEventiHome', filtro);
  },

  stampaAttestatoAsync({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/partecipazioniview/attestato/' + itemId)
        .then(function (response) {
          commit('stampaAttestato', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          reject(err);
        });
    });
  },
  stampaReportIscrittiAsync({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.ROOT_API + '/api/eventiview/' + itemId + '/reportIscrizioni')
        .then(function (response) {
          commit('stampaReportIscritti', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          reject(err);
        });
    });
  },
};

const mutations = {
  addEvento(mdl) {
    window.getApp.$emit('EVENTO_CREATO');
    bus.$emit('eventoDialog', false);
  },
  editEvento(mdl) {
    window.getApp.$emit('EVENTO_MODIFICATO');
    bus.$emit('eventoDialog', false);
  },
  setEvento(mdl, evento) {
    state.evento = evento;
  },
  setInvito(mdl, invito) {
    state.invito = invito;
  },
  setEventoView(mdl, evento) {
    state.eventoView = evento;
  },

  addPartecipazione(mdl) {
    window.getApp.$emit('PARTECIPAZIONE_CREATA');
    bus.$emit('eventoDialog', false);
  },
  editPartecipazione(mdl) {
    window.getApp.$emit('PARTECIPAZIONE_MODIFICATA');
    bus.$emit('eventoDialog', false);
  },
  setPartecipazione(mdl, partecipazione) {
    state.partecipazione = partecipazione;
  },

  setIscrittoEventoSpeciale(mdl, isIscritto) {
    state.eventoSpeciale = isIscritto;
  },

  removePartecipazione(mdl, item) {
    window.getApp.$emit('PARTECIPAZIONE_RIMOSSA');
    bus.$emit('deletePartecipazione', true);
  },
  removePartecipazioni(mdl, item) {
    window.getApp.$emit('PARTECIPAZIONI_RIMOSSE');
    bus.$emit('deletePartecipazione', true);
  },
  addIscrizione(mdl) {
    window.getApp.$emit('ISCRIZIONE_CREATA');
    bus.$emit('eventoDialog', false);
  },
  setIscrizione(mdl, iscrizione) {
    state.iscrizione = iscrizione;
  },
  setEventi(mdl, eventi) {
    state.eventi = eventi;
    state.eventiFiltrati = eventi;
  },
  setPartecipazioni(mdl, partecipazioni) {
    state.partecipazioni = partecipazioni;
    state.partecipazioniFiltrati = partecipazioni;
  },
  setClassificaEvento(mdl, classificaEvento) {
    state.classifica = classificaEvento;
  },
  setRanking(mdl, ranking) {
    state.ranking = ranking;
  },
  setRankingGenerale(mdl, rankingGenerale) {
    state.rankingGenerale = rankingGenerale;
  },
  setClassificaGenerale(mdl, classificaGenerale) {
    state.classificaGenerale = classificaGenerale;
  },
  setRankingPersonale(mdl, rankingPersonale) {
    state.rankingPersonale = rankingPersonale;
  },

  setCalcolaRanking(mdl, rankingPersonale) {
    window.getApp.$emit('RANKING_RICALCOLATA');
    bus.$emit('rankingRefresh', true);
  },

  removeClassifica(mdl, item) {
    window.getApp.$emit('CLASSIFICA_RIMOSSA');
    bus.$emit('classificaUploaded', true);
  },

  removeEvento(mdl, item) {
    window.getApp.$emit('EVENTO_RIMOSSO');
  },
  setImage(mdl, image) {
    state.image = image;
  },
  editImage(mdl) {
    window.getApp.$emit('IMMAGINE_AGGIORNATA');
  },
  editLocandina(mdl) {
    window.getApp.$emit('LOCANDINA_AGGIORNATA');
  },
  editPiazzola(mdl) {
    window.getApp.$emit('PIAZZOLA_AGGIORNATA');
    bus.$emit('piazzolaCaricata', true);
  },
  editClassifica(mdl, message) {
    window.getApp.$emit('CLASSIFICA_AGGIORNATA');
    if (message != '') {
      bus.$emit('erroreClassifica', message);
    } else {
      bus.$emit('rinnovoUploaded', true);
    }
  },
  addPrenotazione(mdl) {
    window.getApp.$emit('PRENOTAZIONE_EFFETTUATA');
    bus.$emit('prenotazioneAggiunta', true);
  },
  exportIscrizioniXLS(mdl, data) {
    // eslint-disable-next-line no-undef
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  exportCalendarioXLS(mdl, data) {
    // eslint-disable-next-line no-undef
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  exportClassificaGeneraleXLS(mdl, data) {
    // eslint-disable-next-line no-undef
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  exportRankingGeneraleXLS(mdl, data) {
    // eslint-disable-next-line no-undef
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  exportClassificaPDF(mdl, data) {
    // eslint-disable-next-line no-undef
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/pdf',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  loadInvito(mdl, data) {
    // eslint-disable-next-line no-undef
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/pdf',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  loadPiazzolaAction(mdl, data) {
    // eslint-disable-next-line no-undef
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/pdf',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  setFiltroEventi(mdl, filtro) {
    state.filtroEventi = filtro;
  },
  setFiltroEventiHome(mdl, filtro) {
    state.filtroEventiHome = filtro;
  },
  stampaAttestato(mdl, data) {
    // eslint-disable-next-line no-undef
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/pdf',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  stampaReportIscritti(mdl, data) {
    // eslint-disable-next-line no-undef
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/pdf',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
